import { render } from "./red4.vue?vue&type=template&id=b6f0bc52&scoped=true"
import script from "./red4.vue?vue&type=script&lang=js"
export * from "./red4.vue?vue&type=script&lang=js"

import "./red4.vue?vue&type=style&index=0&id=b6f0bc52&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6f0bc52"]])

export default __exports__